import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import ContentLayout from "../../../../partials/content/ContentLayout";
import Illustration from "../../../../partials/content/Illustration";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import {
  deleteSalesJourney,
  getSalesJourney,
} from "../../../../services/crm/salesJourney";
import { formatDate } from "../../../../utils/utils";
import { Badge } from "react-bootstrap";
import {
  getRandomColor,
  createImageFromInitials,
} from "../../../../partials/layout/Avatar";
import { Image } from "react-bootstrap";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import { Card } from "primereact/card";
import { isMobile } from "react-device-detect";
function SalesJourney({ history }) {
  const { reload } = useGlobalData();
  const [journeys, setJourneys] = useState([]);
  const [auth, setAuth] = useState({});

  useEffect(() => {
    getSalesJourneyData();
  }, [reload]);

  const salesJourneyDetailColumn = [
    {
      header: "Actual Start Date",
      field: "actStartDate",
      type: "datetime",
    },
    {
      header: "Actual End Date",
      field: "actEndDate",
      type: "datetime",
    },
    {
      header: "Sales Journey Teams",
      field: "journeyTeams",
      type: "string",
    },
    {
      header: "Description",
      field: "description",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <PageSubHeader
        title="Sales Journey List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/crm/sales-journey",
            title: "Sales Journeys",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/menu");
            },
          },
          {
            title: "New Sales Journey",
            color: "primary",
            icon: "fas fa-plus-circle",
            onClick: () => {
              history.push("journey-form");
            },
          },
        ]}
      />
      {!isMobile ? (
        <ContentLayout>
          {journeys.length ? (
            <CustomDataTable
              data={journeys}
              dataDetailColumns={salesJourneyDetailColumn}
              onRefreshData={() => {
                getSalesJourneyData();
              }}
              tableName="salesJourney"
              selectionMode="checkbox"
              columns={[
                {
                  selectionMode: "multiple",
                },
                {
                  header: "Sales Journey ID",
                  field: "ID",
                  body: null,
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Sales Journey Name",
                  field: "title",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis text={rowData.title} maxLine="1" />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Sales Journey Status",
                  field: "statusDesc",
                  body: (rowData) => {
                    if (rowData.statusID === 1) {
                      return (
                        <Badge variant="warning">{rowData.statusDesc}</Badge>
                      );
                    } else if (rowData.statusID === 2) {
                      return (
                        <Badge variant="primary">{rowData.statusDesc}</Badge>
                      );
                    } else if (rowData.statusID === 3) {
                      return (
                        <Badge variant="success">{rowData.statusDesc}</Badge>
                      );
                    } else if (rowData.statusID === 9) {
                      return (
                        <Badge variant="danger">{rowData.statusDesc}</Badge>
                      );
                    } else {
                      return <Badge variant="dark">{rowData.statusDesc}</Badge>;
                    }
                  },
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Plan Start Date",
                  field: "planStartDate",
                  body: (rowData) => formatDate(rowData.planStartDate),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Plan End Date",
                  field: "planEndDate",
                  body: (rowData) => formatDate(rowData.planEndDate),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Assigned To",
                  field: "salesName",
                  body: (rowData) => (
                    <React.Fragment>
                      {rowData.salesID !== 0 ? (
                        <React.Fragment>
                          {rowData.salesUser.userImage ? (
                            <React.Fragment>
                              <div className="kt-widget4">
                                <div className="kt-widget4__item ">
                                  <div className="kt-widget4__pic kt-widget4__pic--pic ">
                                    <Image
                                      src={
                                        rowData.salesUser.userImage.length === 0
                                          ? createImageFromInitials(
                                              150,
                                              rowData.salesUser.fullName,
                                              getRandomColor()
                                            )
                                          : rowData.salesUser.userImage[0]
                                              .imagePath
                                      }
                                      roundedCircle
                                      alt="Avatar"
                                      style={{
                                        width: 32,
                                        height: 32,
                                      }}
                                    />
                                  </div>
                                  <div className="kt-widget4__info ">
                                    <ResponsiveEllipsis
                                      text={rowData.salesName}
                                      maxLine="1"
                                    />
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          ) : null}
                        </React.Fragment>
                      ) : null}
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Actions",
                  body: (rowData) => (
                    <React.Fragment>
                      <BootstrapTooltip title="Sales Journey Detail">
                        <button
                          type="button"
                          onClick={() => {
                            history.push("/crm/journey-detail/" + rowData.ID);
                          }}
                          className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-list-alt"></i>
                        </button>
                      </BootstrapTooltip>
                      {rowData.statusID === 1 ? (
                        <BootstrapTooltip title="Delete Sales Journey">
                          <button
                            type="button"
                            onClick={() => {
                              handleDeleteSalesJourney(rowData.ID);
                            }}
                            className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </BootstrapTooltip>
                      ) : null}
                    </React.Fragment>
                  ),
                  sortable: false,
                },
              ]}
            />
          ) : (
            <Illustration
              imageSource="INVIFO CRM.png"
              description="Hooray! You're ready to have your first Sales Journey!"
              guidance="Hint: track your salespersons activity during approaching a new customer"
              descriptionLeftIcon="fas fa-info-circle kt-font-success"
            ></Illustration>
          )}
        </ContentLayout>
      ) : (
        <React.Fragment>
          {journeys.map((journey, index) => (
            <div
              key={index}
              onClick={() => {
                history.push("/crm/journey-detail/" + journey.ID);
              }}
            >
              <Card title={journey.title}>
                <table>
                  <tr>
                    <td>
                      {journey.statusID === 1 ? (
                        <Badge variant="warning">{journey.statusDesc}</Badge>
                      ) : journey.statusID === 2 ? (
                        <Badge variant="primary">{journey.statusDesc}</Badge>
                      ) : journey.statusID === 3 ? (
                        <Badge variant="success">{journey.statusDesc}</Badge>
                      ) : journey.statusID === 9 ? (
                        <Badge variant="danger">{journey.statusDesc}</Badge>
                      ) : (
                        <Badge variant="dark">{journey.statusDesc}</Badge>
                      )}
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <th>Plan Start Date</th>
                    <td>{formatDate(journey.planStartDate)}</td>
                  </tr>
                  <tr>
                    <th>Plan End Date</th>
                    <td>{formatDate(journey.planEndDate)}</td>
                  </tr>
                  <tr>
                    <th>Assigned To</th>
                    <td>
                      {journey.salesID !== 0 ? (
                        <React.Fragment>
                          {journey.salesUser.userImage ? (
                            <React.Fragment>
                              <div className="kt-widget4">
                                <div className="kt-widget4__item ">
                                  <div className="kt-widget4__pic kt-widget4__pic--pic ">
                                    <Image
                                      src={
                                        journey.salesUser.userImage.length === 0
                                          ? createImageFromInitials(
                                              150,
                                              journey.salesUser.fullName,
                                              getRandomColor()
                                            )
                                          : journey.salesUser.userImage[0]
                                              .imagePath
                                      }
                                      roundedCircle
                                      alt="Avatar"
                                      style={{
                                        width: 32,
                                        height: 32,
                                      }}
                                    />
                                  </div>
                                  <div className="kt-widget4__info ">
                                    {journey.salesName}
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          ) : null}
                        </React.Fragment>
                      ) : null}
                    </td>
                  </tr>
                </table>
              </Card>
            </div>
          ))}
        </React.Fragment>
      )}
    </React.Fragment>
  );

  function handleDeleteSalesJourney(journeyID = 0) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Sales Journey ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteSalesJourney(journeyID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getSalesJourneyData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  async function getSalesJourneyData() {
    const response = await getSalesJourney();
    const { data, auth } = response.data;
    setAuth(auth);
    setJourneys(data.salesJourney);
  }
}

export default SalesJourney;
